<template>
  <span class="vv-bubble">
    <input
      type="checkbox"
      :name="name"
      :value="value"
      :id="value"
      :checked="checked"
      @change="change"
      :disabled="disabled"
    />
    <label :for="value">{{ label }}</label>
  </span>
</template>

<script>
export default {
  name: 'VvCheckboxBubble',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: [Boolean, Array],
    name: String,
    value: String | Number,
    label: String,
    disabled: Boolean
  },
  computed: {
    checked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value)
      }

      return this.modelValue
    }
  },
  methods: {
    change() {
      const value = Array.isArray(this.modelValue) ? [...this.modelValue] : []
      // console.log('value', value)
      if (this.checked) {
        const index = value.findIndex(item => item === this.value)
        value.splice(index, 1)
      } else {
        value.push(this.value)
      }

      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/vv-bubble.scss';
</style>
